/**
 * Extracts the status from quote data returned from the QUOTE_FROM_HASH query.
 * Status can be stored in QuoteStatus (for QuoteType) or ArchivedQuoteStatus (for ArchivedQuoteType).
 *
 * @param quoteData - The quote data from the GraphQL query response
 * @returns The quote status string, or undefined if not found
 */
export function extractQuoteStatus(
  quoteData:
    | {
        __typename?: 'QuoteType' | 'ArchivedQuoteType';
        QuoteStatus?: string;
        ArchivedQuoteStatus?: string;
      }
    | null
    | undefined,
): string | undefined {
  if (!quoteData) {
    return undefined;
  }

  if (
    quoteData.__typename === 'QuoteType' &&
    'QuoteStatus' in quoteData &&
    quoteData.QuoteStatus
  ) {
    return quoteData.QuoteStatus;
  } else if (
    quoteData.__typename === 'ArchivedQuoteType' &&
    'ArchivedQuoteStatus' in quoteData &&
    quoteData.ArchivedQuoteStatus
  ) {
    return quoteData.ArchivedQuoteStatus;
  }

  return undefined;
}
